import { Section, Header } from 'components';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import styles from './FAQ.module.css';
import { FAQCard } from './FAQCard';
type FAQProps = {}

export const FAQ: React.FC<FAQProps> = React.memo(() => {
  const { t } = useTranslation();
  return (
    <Section>
      <Header className={styles.header} noBackground>
        <Col xs="12" className="col-lg-12"><h2>{t('faq-title')}</h2></Col>
      </Header>
      <Row className={styles.faqInfoCard}>
        <Section>
          <Row><h3>{t('faq-info-title')}</h3></Row>
          <Row><p>{t('faq-info')}<br /><Link to={'/support'}>{t('support-team')}</Link>.</p></Row>
        </Section>
      </Row>
      <Row>
        <FAQCard />
      </Row>
    </Section>
    )
});
